var custom = {
  init: function () {
    custom.sliderHome();
    custom.searchBox();
    custom.scrollFilter();
    custom.icoWhats();
    custom.sliderTeacher();
    custom.videoIframe();
    custom.countDown();
    custom.sidebarStickitCustom();
    custom.sliderCertOne();
    custom.moreBlockAll();
    custom.sliderGallery();
    custom.phoneInput();
    custom.hourReserv();
    custom.mapMarket();
    custom.clickVideo();
    custom.sliderRoute();
    custom.shopProduct();
    custom.slideRouteCert();
    //custom.addCommentPage();
  }, 
  sliderHome: function () {
    if ($(".slider-home").length) {
      $(".slider-home").slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: "linear",
      });
      $(".slider-home").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".slider-info").removeClass("aos-init").removeClass("aos-animate");
        }
      );
      $(".slider-home").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          AOS.refresh();
        }
      );
    }
  },
  searchBox: function () {
    (function (window) {
      "use strict";

      function classReg(className) {
        return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
      }

      // classList support for class management
      // altho to be fair, the api sucks because it won't accept multiple classes at once
      var hasClass, addClass, removeClass;

      if ("classList" in document.documentElement) {
        hasClass = function (elem, c) {
          return elem.classList.contains(c);
        };
        addClass = function (elem, c) {
          elem.classList.add(c);
        };
        removeClass = function (elem, c) {
          elem.classList.remove(c);
        };
      } else {
        hasClass = function (elem, c) {
          return classReg(c).test(elem.className);
        };
        addClass = function (elem, c) {
          if (!hasClass(elem, c)) {
            elem.className = elem.className + " " + c;
          }
        };
        removeClass = function (elem, c) {
          elem.className = elem.className.replace(classReg(c), " ");
        };
      }

      function toggleClass(elem, c) {
        var fn = hasClass(elem, c) ? removeClass : addClass;
        fn(elem, c);
      }

      var classie = {
        // full names
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        toggleClass: toggleClass,
        // short names
        has: hasClass,
        add: addClass,
        remove: removeClass,
        toggle: toggleClass,
      };

      // transport
      if (typeof define === "function" && define.amd) {
        // AMD
        define(classie);
      } else {
        // browser global
        window.classie = classie;
      }
    })(window);

    (function (window) {
      "use strict";

      // EventListener | @jon_neal | //github.com/jonathantneal/EventListener
      !window.addEventListener &&
        window.Element &&
        (function () {
          function addToPrototype(name, method) {
            Window.prototype[name] =
              HTMLDocument.prototype[name] =
              Element.prototype[name] =
                method;
          }

          var registry = [];

          addToPrototype("addEventListener", function (type, listener) {
            var target = this;

            registry.unshift({
              __listener: function (event) {
                event.currentTarget = target;
                event.pageX =
                  event.clientX + document.documentElement.scrollLeft;
                event.pageY =
                  event.clientY + document.documentElement.scrollTop;
                event.preventDefault = function () {
                  event.returnValue = false;
                };
                event.relatedTarget = event.fromElement || null;
                event.stopPropagation = function () {
                  event.cancelBubble = true;
                };
                event.relatedTarget = event.fromElement || null;
                event.target = event.srcElement || target;
                event.timeStamp = +new Date();

                listener.call(target, event);
              },
              listener: listener,
              target: target,
              type: type,
            });

            this.attachEvent("on" + type, registry[0].__listener);
          });

          addToPrototype("removeEventListener", function (type, listener) {
            for (
              var index = 0, length = registry.length;
              index < length;
              ++index
            ) {
              if (
                registry[index].target == this &&
                registry[index].type == type &&
                registry[index].listener == listener
              ) {
                return this.detachEvent(
                  "on" + type,
                  registry.splice(index, 1)[0].__listener
                );
              }
            }
          });

          addToPrototype("dispatchEvent", function (eventObject) {
            try {
              return this.fireEvent("on" + eventObject.type, eventObject);
            } catch (error) {
              for (
                var index = 0, length = registry.length;
                index < length;
                ++index
              ) {
                if (
                  registry[index].target == this &&
                  registry[index].type == eventObject.type
                ) {
                  registry[index].call(this, eventObject);
                }
              }
            }
          });
        })();

      // http://stackoverflow.com/a/11381730/989439
      function mobilecheck() {
        var check = false;
        (function (a) {
          if (
            /(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
              a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              a.substr(0, 4)
            )
          )
            check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      }

      // http://www.jonathantneal.com/blog/polyfills-and-prototypes/
      !String.prototype.trim &&
        (String.prototype.trim = function () {
          return this.replace(/^\s+|\s+$/g, "");
        });

      function UISearch(el, options) {
        this.el = el;
        this.inputEl = el.querySelector("form > input.sb-search-input");
        this._initEvents();
      }

      UISearch.prototype = {
        _initEvents: function () {
          var self = this,
            initSearchFn = function (ev) {
              ev.stopPropagation();
              // trim its value
              self.inputEl.value = self.inputEl.value.trim();

              if (!classie.has(self.el, "sb-search-open")) {
                // open it
                ev.preventDefault();
                self.open();
              } else if (
                classie.has(self.el, "sb-search-open") &&
                /^\s*$/.test(self.inputEl.value)
              ) {
                // close it
                ev.preventDefault();
                self.close();
              }
            };

          this.el.addEventListener("click", initSearchFn);
          this.el.addEventListener("touchstart", initSearchFn);
          this.inputEl.addEventListener("click", function (ev) {
            ev.stopPropagation();
          });
          this.inputEl.addEventListener("touchstart", function (ev) {
            ev.stopPropagation();
          });
        },
        open: function () {
          var self = this;
          classie.add(this.el, "sb-search-open");
          // focus the input
          if (!mobilecheck()) {
            this.inputEl.focus();
          }
          // close the search input if body is clicked
          var bodyFn = function (ev) {
            self.close();
            this.removeEventListener("click", bodyFn);
            this.removeEventListener("touchstart", bodyFn);
          };
          document.addEventListener("click", bodyFn);
          document.addEventListener("touchstart", bodyFn);
        },
        close: function () {
          this.inputEl.blur();
          classie.remove(this.el, "sb-search-open");
        },
      };

      // add to global namespace
      window.UISearch = UISearch;
    })(window);

    new UISearch(document.getElementById("sb-search"));
  },
  scrollFilter: function () {
    if ($(".scrollbar-inner").length) {
      $(".scrollbar-inner").scrollbar();
    }
  },
  icoWhats: function () {
    if ($("#block-whats").length) {
      var navigationContainer = $("#block-whats"),
        mainNavigation = navigationContainer.find(
          "#cd-main-whats .block-nav-m"
        );
      $(".cd-whats-trigger").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("menu-is-open");
        mainNavigation
          .off(
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend"
          )
          .toggleClass("is-visible");
      });
    }
  },
  countDown: function () {
    if ($(".listTiempo").length) {
      $("[data-countdown]").each(function () {
        var $this = $(this);
        var finalDate = $(this).data("countdown");
        var timeZone = $(this).data("timezone");
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }

        $this.countdown(newFinalDateTZ, function (event) {
          $this = $(this).html(
            event.strftime(
              "" +
                '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>' +
                '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            )
          );
        });
      });
    }
  },
  sliderTeacher: function () {
    if ($(".slider-teacher").length) {
      $(".slider-teacher").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  sliderRoute: function () {
    if ($(".slider-route-one").length) {
      $(".slider-route-one").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: $(".c-prev-r"),
        nextArrow: $(".c-next-r"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  slideRouteCert: function () {
    if ($(".slider-route-three").length) {
      $(".slider-route-three").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: $(".c-prev-r"),
        nextArrow: $(".c-next-r"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }
  },
  videoIframe: function () {
    $(".item-video").click(function () {
      var htmlVideo = $(this).find(".hidden-video").html();
      var linkSrc = $(this).data("video");
      $("#videoModal").modal("show");
      $("#course-video-content").html(htmlVideo);
      setTimeout(function () {
        $("#course-video-content").find("iframe").attr("src", linkSrc);
      }, 200);
    });
    $("#videoModal").on("hidden.bs.modal", function (event) {
      $("#course-video-content").find("iframe").attr("src", "");
    });
  },
  sidebarStickitCustom: function () {
    if ($(".sidebar-stickit-custom").length) {
      $(".sidebar-stickit-custom").stickit({
        screenMinWidth: 992,
        top: 90,
      });
    }
  },
  moreBlockAll: function () {
    $(".all-t-more .moreActive").on("click", function () {
      $(this).parent().find(".b-p").toggleClass("hide-desc");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).text() == "Ver más") {
        $(this).text("Ver menos");
      } else {
        $(this).text("Ver más");
      }
    });

    $(".t-more-n .moreActive").on("click", function () {
      $(this).parent().find(".b-p1").toggleClass("t-active");
      $(this).parent().find(".b-p1").slideToggle(0);
      if ($(this).hasClass("t-active")) {
        $(this).html('Ocultar resumen <i class="fas fa-chevron-right"></i>');
      } else {
        $(this).html('Ver resumen <i class="fas fa-chevron-right"></i>');
      }
    });
  },
  sliderCertOne: function () {
    if ($(".slider-cert-one").length) {
      $(".slider-cert-one").slick({
        arrows: true,
        prevArrow: $(".c-prev"),
        nextArrow: $(".c-next"),
        dots: true,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
  sliderGallery: function () {
    if ($(".inner-gallery-event").length) {
      $(".popup-gallery-lead").magnificPopup({
        delegate: "a",
        type: "image",
        tLoading: "Cargando imagen #%curr%...",
        mainClass: "mfp-img-mobile",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: "",
          titleSrc: function (item) {
            return item.el.attr("title");
          },
        },
      });
    }
  },
  phoneInput: function () {
    if ($("#inputPhoneNumberRegInf").length) {
      var inputPhoneNumberRegInf = document.querySelector(
        "#inputPhoneNumberRegInf"
      );
      var countryCode = $("#inputPhoneNumberRegInf").data("country");
      if (countryCode == "") {
        countryCode = "pe";
      }
      var intPhoneNumberReg = intlTelInput(inputPhoneNumberRegInf, {
        initialCountry: countryCode,
        //utilsScript: main.host + "dist/js/utils.js",
        utilsScript:
          "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
        preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
        placeholderNumberType: "MOBILE",
        separateDialCode: true,
      });
    }
  },
  hourReserv: function () {
    if ($(".block-calendar-reserv").length) {
      $("#datepickerMent").datepicker({
        language: "es",
        todayHighlight: true,
      });

      if ($(".footer-calendar-m").length) {
        $(".hour-select").customSelect();
      }
      $(".event-resv").click(function () {
        var eventR = $(this);
        eventR.hide();
        eventR.parent("li").find(".resv-btn").show();
      });
    }
  },
  mapMarket: function () {
    if ($(".map-canvas").length) {
      $(".mapShow").click(function (e) {
        e.preventDefault();
        $(".mapShow").remove();
        $(".map-canvas").addClass("map-show");
        var lat = $(".map-canvas").data("lat");
        var log = $(".map-canvas").data("lon");
        var direc = $(".map-canvas").data("direc");

        var map = new google.maps.Map($(".map-canvas")[0], {
          zoom: 16,
          center: new google.maps.LatLng(lat, log),
        });
        var marker = new google.maps.Marker({
          map: map,
          position: new google.maps.LatLng(lat, log),
        });
        var info = new SnazzyInfoWindow({
          marker: marker,
          closeOnMapClick: false,
          content: direc,
        });
        info.open();
      });
    }
  },
  clickVideo: function () {
    if ($(".video-m").length) {
      $(".video-m").click(function () {
        $(this).hide();
        $(this).siblings(".b-content-video").show();
        $(this).siblings(".b-content-video").addClass("video-concl");
      });
    }
    if ($(".video-iframe-t").length) {
      $(".video-iframe-t").click(function () {
        $(this).hide();
        $(this).siblings(".b-content-video").show();
        $(this).siblings(".b-content-video").addClass("video-concl");
      });
    }
    $("#reserveModal").on("hidden.bs.modal", function (event) {
      $("#block-reserv-c").show();
      $("#listHourCalendar").hide();
      $(".btn-return").hide();
    });
  },
  shopProduct: function () {
    $(".slider-product-image").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".slider-product-thumbnail",
    });
    $(".slider-product-thumbnail").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".slider-product-image",
      dots: false,
      focusOnSelect: true,
      infinite: false,
      prevArrow: $(".prev-product"),
      nextArrow: $(".next-product"),
    });
  },
  addCommentPage: function () {
    var myModalComment = document.getElementById("commentModal");
    myModalComment.addEventListener("shown.bs.modal", function (event) {
      console.log("Aparecio el modal");
      $(".eventAddComment").click(function () {
        $.ajax({
          url: "dist/comment.json",
          method: "GET",
          dataType: "json",
          success: function (data) {
            $.each(data, function (i, item) {
              console.log("all");
              var index = parseInt(i);
              index++;
              var templateComment = `<div class="col-md-6">
                  <div class="clear-fix list-answer">
                    <div class="clear-fix item-answer">
                      <figure
                        style="
                          background: url(${item["img"]}) no-repeat;
                          background-size: cover;
                        "
                      >
                        <img src="${item["img"]}" alt="" />
                      </figure>
                      <div class="clear-fix name-start">
                        <h3>${item["name"]}</h3>
                        <div class="start-calf">
                          <i class="fas fa-star"></i>
                          <i class="fas fa-star"></i>
                          <i class="fas fa-star"></i>
                          <i class="fas fa-star-half-alt"></i>
                          <i class="far fa-star"></i>
                        </div>
                        <span>${item["fech"]}</span>
                      </div>
                    </div>
                    <p>${item["desc"]}</p>
                  </div>
                </div>`;
              $("#dataComment").append(templateComment);
            });
          },
          error: function (error) {
            console.error("Error:", error);
          },
        });
      });
    });
  },
};
